import { SearchIcon } from "lucide-react"
import { useState } from "react"

const SearchBar = ({ onSubmit, placeholder, onChange, value }) => {
  const [focus, setFocus] = useState(false)

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit?.()
      }}
      className={`
        ${focus ? "border-gray-800" : "border-gray-300"}
        flex items-center border px-3 py-1.5 rounded-sm
      `}
    >
      <button type="submit" className="cursor-pointer">
        <SearchIcon className="text-gray-300" size={20} />
      </button>

      <input
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        className="px-2 pt-0.5 min-w-80 outline-none w-full"
        type="text"
        placeholder={placeholder}
        onChange={onChange}
        value={value}
      />
    </form>
  )
}

export default SearchBar
